import React from "react";
import { dataCzas } from "../../../../functions/dataFormat";
import { zl } from "../../../../functions/utilities";
import { adresPro2 } from "../../../../functions/ulice";

const WspolnotaRozliczenieHistoriaTBody = props => {

    const { zaleglosciPowiadomienia, mieszkancy, udzialyKontaAkt, lokale, ulice, grupy } = props;

    

    const lista = zaleglosciPowiadomienia && zaleglosciPowiadomienia?.map( (z, i) => {

        const mieszkaniec = mieszkancy && mieszkancy?.find( m => m?.id_user == z?.id_user)?.imie_nazwisko;
        const udzial = udzialyKontaAkt && udzialyKontaAkt?.find( u => u?.id_user == z?.id_user && u?.grupa_numer == z?.grupa_numer);
        const adres = adresPro2(udzial, lokale, ulice, grupy);

        return (
            <tr key={i}>
                <td>
                    {`${mieszkaniec} (${z?.id_user})`}
                </td>
                <td>
                    {`${adres} (grupa ${z?.grupa_numer})`}
                </td>
                <td>
                    {z?.kanal}
                </td>
                <td>
                    {dataCzas(z?.data_utworzenia)}
                </td>
                <td>
                    {z?.nadawca}
                </td>
                <td>
                    {zl(z?.kwota)}
                </td>
                <td>
                    {z?.uwagi}
                </td>
            </tr>
        )
    })

    return (
        <tbody>
            { lista }
        </tbody>
    )
}

export default WspolnotaRozliczenieHistoriaTBody;